import * as constants from "../../../../constants";

import { GetProgressGraphParams, GetProgressGraphResult } from "@/components/home/ProgressDashboard/actions/types";
import environments from "@/environments";

// 進捗グラフ用データ取得
export const getProgressGraph = (params: GetProgressGraphParams, callback?: (res: GetProgressGraphResult) => void) => {
  const endpoint = `${environments.API_BASE_URI}/progress_graph`;

  const query = new URLSearchParams();
  params.category_id && query.append("category_id", params.category_id.toString());
  params.primary_charge_id && query.append("primary_charge_id", params.primary_charge_id.toString());
  params.area_id && query.append("area_id", params.area_id.toString());
  params.device_id && query.append("device_id", params.device_id.toString());
  params.date_from && query.set("date_from", params.date_from);
  params.date_to && query.set("date_to", params.date_to);

  return {
    type: constants.APP_CALL_API,
    endpoint: `${endpoint}?${query.toString()}`,
    method: "GET",
    callbacks: {
      begin: () => {
        return {
          type: constants.HOME_PROGRESS_GRAPH_BEGIN_FETCH,
          payload: params,
        };
      },
      success: (response) => {
        callback?.(response);

        return {
          type: constants.HOME_PROGRESS_GRAPH_END_FETCH,
          payload: response,
        };
      },
      error: (response) => {
        return {
          type: constants.APP_SHOW_ERROR,
          payload: response,
          error: true,
        };
      },
    },
  };
};
